<template>

  <div style="background: #f2f2f6; height: 100%">
    <el-form size="mini" label-width="100px" class="demo-form-inline">

       <el-form-item :label="$t('base.timeInterval')">
           <el-date-picker
      v-model="value1"
    type="datetimerange"
    :range-separator="$t('base.to')"
    :start-placeholder="$t('base.beginTime')"
    size="mini"
    value-format="yyyy-MM-dd HH:mm:ss"
    :default-time="['00:00:00','23:59:59']"
    :end-placeholder="$t('base.endTime')">
  </el-date-picker>
     <el-button size="small" type="primary"  @click="search()">{{this.$t("base.search")}}</el-button>
  </el-form-item>
  <el-row  >
      <el-form-item :label="$t('device.heatpumpSelect')" v-if="heatpump.length>1">
   <el-select
                size="mini"
                v-model="$store.state.deviceinnerid"
                
                @change="changeDevice"

              >
                <el-option
                  v-for="item in heatpump"
                  :key="item.innerid"
                  :label="item.name"
                  :value="item.innerid"
                  v-if="item.subdevs<=($store.state.slavenum+1)"
                >
                </el-option>
              </el-select>
  </el-form-item>
      <el-form-item :label="$t('device.paramSelect')">
    <el-button icon="el-icon-s-data" type="primary"  @click="open">{{$t("device.paramSelect")}}</el-button>
  </el-form-item>
    </el-row>
      <el-form-item :label="$t('device.showType')">
    <el-switch
    style="font-size:12px"
  v-model="together"
  @change="sizeChange"
  :active-text="$t('device.showToge')"
  :inactive-text="$t('device.showSingl')">
</el-switch>
  </el-form-item>
    </el-form>

    <el-row style="padding:0 10px">
      <el-col v-show="together&&dplist.length>0"  v-loading="loading"  element-loading-background="rgba(255, 255, 255, 0.8)"  :span='24' style="height:370px;">
        <div id="togetherDiv" style="width:100%;height:370px">
      </div>
      </el-col>
      <el-col v-show="!together" v-loading="loading"  element-loading-background="rgba(255, 255, 255, 0.8)"  :span='6' style="height:270px; border:1px #bbbbbb dashed" v-for="dp in dplist" :key="dp.innerid">
        <div :id="dp.innerid" style="width:100%;height:100%">
        </div>
      </el-col>

    </el-row>
    <el-dialog v-if="device" style="overflow:auto" :title="$t('device.paramSelect')" width="660px" :visible.sync="dialogTableVisible">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
  <el-row style="padding-top:5px;overflow:auto;height:450px" >
    <el-col v-for="item in alldp" v-if="!(user.logintype==2&&item.hide)&&getValiddp(item)" :key="item.innerid" :span="8"  style="text-align:left"><el-checkbox @change="changedp()" v-model="item.checked">{{item.desc}}</el-checkbox></el-col>
  </el-row>
  <el-row style="margin-top:20px">
    <el-button icon="el-icon-check" size="small" type="warning" @click="save()">{{$t('base.confirm')}}</el-button>
  </el-row>
    </el-dialog>
  </div>

</template>

<script>
import Vue from 'vue'
let chartToge = null
export default {
  name: 'Report',
  data () {
    return {
      user: {},
      value1: [],
      alldp: [],
      isIndeterminate: false,
      checkAll: false,
      together: true,
      dplist: [],
      echarts: {},
      reportdata: null,
      dialogTableVisible: false,
      loading: false,
      deviceChange: true
      // isMobile: true
    }
  },
  computed: {
    device () {
      return this.$store.state.devicelist.filter(d => { return d.innerid == this.$store.state.deviceinnerid })[0]
    },
    heatpump () {
      return this.$store.state.devicelist.filter(d => { return d.type == 'heatpump' })
    }
  },
  mounted: function () {
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      this.user = JSON.parse(customer)
      let yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      this.value1 = [yesterday.Format('yyyy-MM-dd HH:mm:00'), (new Date()).Format('yyyy-MM-dd HH:mm:00')]
      //this.search()
    } else {
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    handleCheckAllChange () {
      let self = this
      this.alldp.forEach(dp => {
        dp.checked = self.checkAll
      })
      this.isIndeterminate = false
    },
    changedp () {
      let checked = this.alldp.filter(dp => { return dp.checked })
      if (checked.length > 0 && checked.length < this.alldp.length) {
        this.isIndeterminate = true
        this.checkAll = false
      } else {
        if (checked.length == this.alldp.length) {
          this.checkAll = true
        }
        this.isIndeterminate = false
      }
    },
    changeDevice () {
      this.deviceChange = true
      this.$store.state.device = this.heatpump.filter(d => { return d.innerid == this.$store.state.deviceinnerid })[0]
      this.$forceUpdate()
    },
    open: function () {
      if (this.alldp.length == 0 || this.deviceChange) {
        this.alldp = this.device.dplist.filter(d => { return d.type==2&& d.xrw == 2 && (!d.subhide || (d.subhide === 1 && this.$store.state.device.subdevs === 1) || (this.$store.state.device.subdevs > 1 && d.subhide > 1)) }).map(d => {
          // return {checked: ['temp_o', 'temp_b', 'temp'].includes(d.name), innerly: d.innerid, name: d.name, desc: d.desc}
          return {checked: false, innerid: d.innerid, name: d.name, desc: d.desc,validdt:d.validdt,validdp:d.validdp,hide:d.hide}
        })
        this.alldp.unshift({checked: false, innerid: 'outhumi', name: 'outhumi', desc: this.$t('base.outerHumid')})
        this.alldp.unshift({checked: false, innerid: 'outtemp', name: 'outtemp', desc: this.$t('base.outerTemp')})
        this.deviceChange = false
      }
      this.dialogTableVisible = true
    },
    search: function () {
      if (this.value1 && this.value1.length == 2) {
        var self = this
        this.loading = true
        Vue.axios
          .post('/report/heatpump/query', {startdate: this.value1[0], enddate: this.value1[1], deviceid: this.$store.state.deviceinnerid, tags:this.alldp.filter(d => { return d.checked }).map(d => { return d.name })})
          .then((res) => {
            if (res.data.errcode == 0) {
              self.reportdata = res.data.msgbody
              self.build()
            }
          })
      } else {
        this.$message({
          message: this.$t('base.requireTimeInterval'),
          type: 'warning'
        })
      }
    },
    getValiddp (dp) {
      if (dp.validdp) {
        let cdp = this.device.dplist.filter(d => { return d.dpid == dp.validdp })
        if (cdp && cdp.length > 0) {
          if (JSON.parse(dp.validdt).indexOf(this.device[cdp[0].name]) >= 0) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return true
      }
    },
    build:function(){
      var self = this
      chartToge = this.$echarts.init(document.getElementById('togetherDiv'), 'shine')
      chartToge.setOption(buildTogOption(this.reportdata, this.dplist), true)
      setTimeout(function () {
        chartToge.resize()
      }, 500)
      setTimeout(function () {
        self.dplist.forEach(dp => {
          self.echarts[dp.name] = self.$echarts.init(document.getElementById(dp.innerid), 'shine')
          self.echarts[dp.name].setOption(buildOption(self.reportdata, dp.name, dp.desc), true)
          if (dp.name != 'powerused') {
            self.echarts[dp.name].group = 'group1'
          }
          self.echarts[dp.name].resize()
          self.loading = false
        })
        self.$echarts.connect('group1')
      }, 500)
    },
    save: function () {
      this.loading = true
      this.dplist = this.alldp.filter(d => { return d.checked })
      this.dialogTableVisible = false
      this.search()
    },
    sizeChange: function () {
      let self = this
      setTimeout(function () {
        chartToge.resize()
        for (var key in self.echarts) {
          self.echarts[key].resize()
        }
      }, 500)
    }
  }
}

function buildTogOption (data, dplist) {
  let series = []
  let legendData = []
  dplist.forEach(dp => {
    legendData.push(dp.desc)
    series.push({
      name: dp.desc,
      type: 'line',
      data: data[dp.name],
      smooth: false,
      showSymbol: true
    })
  })

  return {
    title: {
      show: false
    },
    // color: ['#73c0de'],
    grid: {
      left: '5%',
      top: '10%',
      right: '5%',
      bottom: '20%'
    },
    tooltip: {
      trigger: 'axis'
    },
    toolbox: {
      show: true,
      top: 0,
      right: 50,
      feature: {
        dataView: { readOnly: true,
          optionToContent: function (opt) {
            var axisData = opt.xAxis[0].data
            var series = opt.series
            var table = '<input style="margin-left:20px;" type="submit" value="下载数据" onclick="download(\'table\',\'报表数据\');"><table id="table" border="1" cellspacing="0" style="width:100%;text-align:center;font-size:12px;color:#666666"><tbody><tr>' +
                                     '<td>时间</td>'
            for (var i = 0; i < series.length; i++) {
              table += '<td>' + series[i].name + '</td>'
            }
            table += '</tr>'
            for (var i = 0; i < axisData.length; i++) {
              table += '<tr>'
              table += '<td>' + (axisData[i] || '') + '</td>'
              for (var j = 0; j < series.length; j++) {
                let value = ''
                if (series[j].data && (series[j].data[i] || series[j].data[i] == 0)) {
                  value = series[j].data[i]
                }
                table += '<td>' + value + '</td>'
              }
              +'</tr>'
            }
            table += '</tbody></table>'
            return table
          } },
        saveAsImage: {}
      }
    },
    legend: {
      show: true,
      type: 'scroll',
      data: legendData,
      bottom: 0
    },
    xAxis: {
      type: 'category',
      axisLine: { show: true, lineStyle: { color: '#dddddd' } },
      axisLabel: {
        color: '#929292'
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dotted',
          color: '#dddddd'
        }

      },
      splitNumber: 10,
      boundaryGap: false,
      data: data.x
    },
    yAxis: {
      type: 'value',
      //  splitNumber: 10,
      // min: 0,
      // max: function (value) {
      //   if(key.split('snrco2').length > 1 ) {
      //     return value.max = 2000
      //   }else if(key.split('snrpm2.5').length > 1 ) {
      //     return value.max = 100
      //   }
      // },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#dddddd'
        }
      },
      axisLine: { show: true, lineStyle: { color: '#dddddd' } },
      axisLabel: {
        formatter: '{value}',
        color: '#929292'
      },
      axisTick: { length: 0 }
    },
    series: series

  }
}

function buildOption (data, key, reporttitle) {
  var series = []
  series = [{
    name: reporttitle,
    type: 'line',
    data: key == 'powerused' ? data.acb.y : data[key],
    smooth: false,
    showSymbol: true
  }]
  return {
    title: {
      show: true,
      text: reporttitle,
      textStyle: {
        color: '#606266',
        fontSize: 16
      }

    },
    color: ['#73c0de'],
    grid: {
      left: '15%',
      top: '15%',
      right: '5%',
      bottom: '10%'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      show: false,
      data: ['PM2.5'],
      right: 0
    },
    xAxis: {
      type: 'category',
      axisLine: { show: true, lineStyle: { color: '#dddddd' } },
      axisLabel: {
        color: '#929292'
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dotted',
          color: '#dddddd'
        }

      },
      splitNumber: 10,
      boundaryGap: false,
      data: key == 'powerused' ? data.acb.x : data.x
    },
    yAxis: {
      type: 'value',
      //  splitNumber: 10,
      min: function (value) {
        if (reporttitle.split('室内温度').length > 1) {
          let Data = key == 'powerused' ? data.acb.y : data[key]
          let Temp = Data.filter((x) => {
            return x < 10
          })
          let temp
          if (Temp.length > 0) {
            temp = 0
          } else {
            temp = 10
          }
          return value.min = temp
        }
      },
      // max: function (value) {
      //   if(key.split('snrco2').length > 1 ) {
      //     return value.max = 2000
      //   }else if(key.split('snrpm2.5').length > 1 ) {
      //     return value.max = 100
      //   }
      // },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#dddddd'
        }
      },
      axisLine: { show: true, lineStyle: { color: '#dddddd' } },
      axisLabel: {
        formatter: '{value}',
        color: '#929292'
      },
      axisTick: { length: 0 }
    },
    series: series

  }
}

Date.prototype.Format = function (formatStr) {
  var str = formatStr
  var Week = ['日', '一', '二', '三', '四', '五', '六']

  str = str.replace(/yyyy|YYYY/, this.getFullYear())
  str = str.replace(
    /yy|YY/,
    this.getYear() % 100 > 9
      ? (this.getYear() % 100).toString()
      : '0' + (this.getYear() % 100)
  )

  str = str.replace(
    /MM/,
    this.getMonth() > 8 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1)
  )
  str = str.replace(/M/g, this.getMonth())

  str = str.replace(/w|W/g, Week[this.getDay()])

  str = str.replace(
    /dd|DD/,
    this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate()
  )
  str = str.replace(/d|D/g, this.getDate())

  str = str.replace(
    /hh|HH/,
    this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours()
  )
  str = str.replace(/h|H/g, this.getHours())
  str = str.replace(
    /mm/,
    this.getMinutes() > 9
      ? this.getMinutes().toString()
      : '0' + this.getMinutes()
  )
  str = str.replace(/m/g, this.getMinutes())

  str = str.replace(
    /ss|SS/,
    this.getSeconds() > 9
      ? this.getSeconds().toString()
      : '0' + this.getSeconds()
  )
  str = str.replace(/s|S/g, this.getSeconds())

  return str
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .popperClass {
    width: 12.5rem /* 200/16 */;
  }
</style>
<style>
.el-switch__label *{
  font-size: 12px;
}</style>



// WEBPACK FOOTER //
// src/components/Devices/Report.vue